<script lang="ts">
  import { History } from "lucide-svelte";
  interface Props {
    yesterdayPv: number;
    yesterdayUv: number;
    t: (path: string) => string;
  }
  let { yesterdayPv, yesterdayUv, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between bg-muted/20">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.yesterday_traffic')}</p>
    <History class="h-4 w-4 text-muted-foreground" />
  </div>
  <div class="mt-2 flex items-baseline gap-3">
    <div>
      <span class="text-2xl font-bold tracking-tight">{yesterdayPv}</span>
      <span class="text-xs text-muted-foreground ml-0.5">{t('dashboard.kpi.pv_label')}</span>
    </div>
    <div class="h-4 w-px bg-border"></div>
    <div>
      <span class="text-2xl font-bold tracking-tight">{yesterdayUv}</span>
      <span class="text-xs text-muted-foreground ml-0.5">{t('dashboard.kpi.uv_label')}</span>
    </div>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.full_day_settled')}</span>
    <span>{t('dashboard.kpi.archived')}</span>
  </div>
</div>